<template>
    <div class="filesearch">
        <v-container fluid class="pa-2">
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="search_text"
                        label="Enter search text"
                        hint="e.g. path/to/your/file/*.txt"
                        clearable
                        dense
                        v-on:keyup.enter="get_filtered_filelist"
                        v-on:click:clear="clear_file_search"
                        class="body-2"
                    ></v-text-field>
                </v-col>
                <!--v-col cols="6">
                    <v-btn v-if="this.active_nodes.length > 0" depressed x-small color="error" class="float-right" @click="delete_items">
                        Delete
                    </v-btn>
                    <v-btn v-if="this.active_nodes.length > 0" depressed x-small color="success" class="float-right mr-1" @click="download_items">
                        Download
                    </v-btn>
                </v-col-->
            </v-row>
            <v-row no-gutters v-if="!file_search_loading">
                <v-col cols="12">
                    <v-card 
                        v-if="filtered_project_files.length > 0"
                        elevation="16"
                        class="mx-auto"
                    >
                        <v-container fluid>
                            <v-virtual-scroll
                                :items="filtered_project_files"
                                height="475"
                                item-height="32"
                            >
                                <template v-slot:default="{ item }">
                                            <v-list-item dense :key="item.Key" class="pa-0 ma-0">
                                                <v-list-item-content class="pa-0">
                                                    <v-list-item-title>
                                                        {{item.Key}} <span class="caption grey--text">({{humanFileSize(item.Size)}}) - {{item.LastModified}}</span>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                    <v-divider></v-divider>
                                </template>
                            </v-virtual-scroll>
                        </v-container>
                        <!--v-container fluid class="pa-0">
                            <v-list dense height="475">
                                <v-list-item-group v-model="selected_files" multiple>
                                    <v-list-item v-for="item in filtered_project_files" :key="item.Key" class="px-2">
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title class="caption font-weight-regular">
                                                {{item.Key}} <span class="grey--text caption">({{humanFileSize(item.Size)}}) - {{item.LastModified}}</span>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-container-->
                    </v-card>

                    <v-card v-else>
                        <v-card-text class="body-2 error--text">
                            No matching files
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12">
                    <v-dialog
                        v-model="file_search_loading"
                        hide-overlay
                        persistent
                        width="300"
                    >
                        <v-card
                            color="primary"
                            dark
                        >
                            <v-card-text>
                                Loading files...
                                <v-progress-linear
                                    indeterminate
                                    color="white"
                                    class="mb-0"
                                ></v-progress-linear>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios';
import wmatch from 'wildcard2';

export default {
  name: "FileSearch",
  props: {
    project: {
      type: String
    }
  },
  data() {
    return {
        selected_files: [],
        project_files : [],
        file_search_loading: false,
        current_user: null,
        filtered_project_files: [],
        search_text: null
    }
  },
  created () {
    this.get_filelist();
  },
  methods: {
    get_filelist(){
        this.file_search_loading = true;
        axios.get(`https://${this.$assetAPI}/user/resource?path=${this.project}&scoped=false&sequence=false`)
        .then(resp => {
            this.project_files = resp.data.files;
            //this.filtered_project_files = resp.data.files;
            this.file_search_loading = false;
        })
        .catch(error => {
            this.file_search_loading = false;
            if (error.response){
                if (error.response.status == 401){
                    this.$session.destroy();
                    this.$router.push('/login');
                }
            }
        })
    },
    get_filtered_filelist() {
        if (!this.search_text || !this.search_text.length){
            this.clear_file_search();
            return;
        }else{
            this.search_text = this.search_text.trim();
        }
        this.filtered_project_files = this.project_files.filter(pf => {
            return wmatch(pf.Name.toLowerCase(), this.search_text.toLowerCase());
        })
    },
    clear_file_search() {
        this.search_text = null;
        this.filtered_project_files = this.project_files;
    },
    humanFileSize(bytes, si=false, dp=1) {
        const thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }

        const units = si 
            ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
            : ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            //: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        const r = 10**dp;

        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

        return bytes.toFixed(dp) + ' ' + units[u];
    }
  }
}
</script>
<style scoped>
.v-list-item__title{
    font-size: .75rem;
    font-weight: normal;
}
</style>